import React, { Component } from 'react';
import { Card, CardBody, Button, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Container } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import SearchIcon from '@material-ui/icons/Search';
import Modal from '@material-ui/core/Modal';
import Spinner from 'react-bootstrap/Spinner';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PrintIcon from '@material-ui/icons/Print';
import ManualInvoicePDF from './ManualInvoicePDF';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookMedical, faBox } from "@fortawesome/free-solid-svg-icons";
import ArticlesForm from '../../Inventory/Articles/components/ArticlesForm';
import ModalInventoryList from './ModalInventoryList';
import ModalServicesList from './ModalServicesList';
import FormItem from './FormItem';
import { formatNumber } from '../../Utils/Money';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ItemsList from './ItemsList';
import ItemsListActions from './ItemsListActions';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import FormInvoiceData from './FormInvoiceData';
import FormClientInvoice from './FormClientInvoice';
import AlertModal from '../../../shared/components/Modal';
import history from '../../../history';
import SaveIcon from '@material-ui/icons/Save';
import { InvoiceUtils } from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/InvoiceUtils';
import ModalTemplatePdf from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/ModalTemplatePDF';

class ManualInvoiceReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            typeBusiness: "CONTADO",
            typeClient: null,
            client: {
                num_document: null,
                type_document: null,
                name: null,
                adress: null,
                country: null,
                departament: null,
                city: null,
                phone: null,
                email: null
            },
            invoiceEndDate: null,
            money: null,
            paymentConcept: "PARTICULAR",
            paymentMethod: null,
            totalFormat: 0,
            services: [],
            modalServices: false,
            modalInventory: false,
            loading: false,
            addedItems: [],
            profile: [],
            urlLogo: sessionStorage.getItem('logoURL'),
            item: null,
            cost: null,
            units: null,
            itemType: null,
            taxType: "Sin Impuesto",
            activeTab: "1",
            id_inventario: null,
            id_servicio: null,
            errors: {},
            colorAlertModal: 'info',
            titleAlertModal: "",
            openAlertModal: false,
            messageAlertModal: "",
            openModalPrintPDF: false,
            acc_valor_iva: 0
        };
    };

    componentDidMount() {

    }

    preAddItemArticle = (article) => {
        console.log("ARTICULO", article)
        this.setState({
            id_servicio: null,
            id_inventario: article.id_inventario,
            item: article.articulo,
            cost: article.valor_venta,
            units: article.stock,
            itemType: "Articulo"
        }, () => {
            this.setState({ modalInventory: false });
        });
    }

    preAddItemService = (service) => {
        this.setState({
            id_servicio: service.id_servicio,
            id_inventario: null,
            item: service.nombre,
            cost: null,
            units: 1,
            itemType: "Servicio"
        }, () => {
            this.setState({ modalServices: false });
        });
    }

    addItem = (itemAdd) => {
        console.log("ARtiiculoAdded", itemAdd);
        itemAdd.id_servicio = this.state.id_servicio;
        itemAdd.id_inventario = this.state.id_inventario;
        this.setState({ acc_valor_iva: this.state.acc_valor_iva + itemAdd.valor_iva }, () => console.log("IVA", this.state.acc_valor_iva))
        let newTotal = parseFloat(this.state.totalFormat);
        newTotal = parseFloat(newTotal) + parseFloat(itemAdd.valor_total);
        newTotal = Math.ceil(newTotal);
        this.setState({ addedItems: [...this.state.addedItems, itemAdd], totalFormat: newTotal }, () => {
            this.setState({
                item: "",
                cost: "",
                units: "",
                itemType: "",
                taxType: ""
            });
        });
    }

    removeItem = (index, item) => {
        this.state.addedItems.splice(index, 1);
        let item_valor = parseFloat(item.valor_total);
        item_valor = Math.ceil(item_valor);

        let item_iva = parseFloat(item.valor_iva);
        item_iva = Math.ceil(item_iva);

        let newIva = parseFloat(this.state.acc_valor_iva) - parseFloat(item_iva);
        newIva = Math.ceil(newIva);
        
        this.setState({ totalFormat: this.state.totalFormat - item_valor, acc_valor_iva: newIva });
    }

    calculateTotal = () => {
        let subtotal = this.state.totalFormat != null && this.state.totalFormat != undefined && this.state.totalFormat != "" ? parseFloat(this.state.totalFormat) : 0;
        let copago = this.state.money != null && this.state.money != undefined && this.state.money != "" ? parseFloat(this.state.money) : 0;
        let total = parseFloat(subtotal) - parseFloat(copago);
        console.log("totalInvoice", total);
        return total;
    }

    handleItem = (value) => {
        this.setState({ item: value });
    }

    handleCost = (value) => {
        this.setState({ cost: value });
    }

    handleUnits = (value) => {
        this.setState({ units: value });
    }

    handleItemType = (value) => {
        this.setState({ itemType: value });
    }

    handleTaxType = (value) => {
        this.setState({ taxType: value });
    }

    handleClient = (value, dataClient) => {
        this.setState({
            client: {
                ...this.state.client, [dataClient]: value
            }
        }, () => {
            console.log("clienteFinal", this.state.client);
        });
    }

    handleMoney = (value) => {
        this.setState({ money: value });
    }

    handlePaymentConcept = (value) => {
        this.setState({ paymentConcept: value });
    }

    handlePaymentMethod = (value) => {
        this.setState({ paymentMethod: value });
    }

    handleTypeBusiness = (value) => {
        this.setState({ typeBusiness: value });
    }

    handleTypeClient = (value) => {
        this.setState({ typeClient: value });
    }

    handleInvoiceEndDate = (value) => {
        this.setState({ invoiceEndDate: value });
    }

    cleanDataPatient = () => {
        this.setState({
            client: {
                num_document: "",
                type_document: "",
                name: "",
                adress: "",
                country: "",
                departament: "",
                city: "",
                phone: "",
                email: ""
            },
        }, () => {
            this.setState({
                client: {
                    num_document: null,
                    type_document: null,
                    name: null,
                    adress: null,
                    country: null,
                    departament: null,
                    city: null,
                    phone: null,
                    email: null
                },
            })
        });
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        };
    };

    validate = () => {
        let errors = {};
        let error = false;

        if (this.state.client.type_document == null || this.state.client.type_document == undefined || this.state.client.type_document == "") {
            errors.type_document = "El Tipo de Documento del Cliente es Obligatorio";
            error = true;
        }

        if (this.state.typeClient == null || this.state.typeClient == undefined || this.state.typeClient == "") {
            errors.typeClient = "El Tipo de Cliente es Obligatorio";
            error = true;
        }

        if (this.state.client.num_document == null || this.state.client.num_document == undefined || this.state.client.num_document == "") {
            errors.num_document = "El Número de Documento del Cliente es Obligatorio";
            error = true;
        }

        if (this.state.client.name == null || this.state.client.name == undefined || this.state.client.name == "") {
            errors.name = "El Nombre es Obligatorio";
            error = true;
        }

        if (this.state.client.adress == null || this.state.client.adress == undefined || this.state.client.adress == "") {
            errors.adress = "La Dirección del Cliente es Obligatorio";
            error = true;
        }

        if (this.state.client.country == null || this.state.client.country == undefined || this.state.client.country == "") {
            errors.country = "El País del Cliente es Obligatorio";
            error = true;
        }

        if (this.state.client.departament == null || this.state.client.departament == undefined || this.state.client.departament == "") {
            errors.departament = "El Departamento del Cliente es Obligatorio";
            error = true;
        }

        if (this.state.client.city == null || this.state.client.city == undefined || this.state.client.city == "") {
            errors.city = "La Ciudad del Cliente es Obligatoria";
            error = true;
        }

        if (this.state.client.phone == null || this.state.client.phone == undefined || this.state.client.phone == "") {
            errors.phone = "El Número de Telefono o Celular es Obligatorio";
            error = true;
        }

        if (this.state.client.email == null || this.state.client.email == undefined || this.state.client.email == "") {
            errors.email = "El Correo Electronico es Obligatorio";
            error = true;
        }

        /*
        if (this.state.money == null || this.state.money == undefined || this.state.money == "") {
            errors.money = "El valor de Copago es Obligatorio";
            error = true;
        }*/

        if (this.state.typeBusiness == null || this.state.typeBusiness == undefined || this.state.typeBusiness == "") {
            errors.typeBusiness = "El Tipo de Negociación es Obligatorio";
            error = true;
        }

        if (this.state.paymentConcept == null || this.state.paymentConcept == undefined || this.state.paymentConcept == "") {
            errors.paymentConcept = "El Concepto de Pago es Obligatorio";
            error = true;
        }


        if (this.state.paymentMethod == null || this.state.paymentMethod == undefined || this.state.paymentMethod == "") {
            errors.paymentMethod = "El Metodo de Pago es Obligatorio";
            error = true;
        }

        if (this.state.invoiceEndDate == null || this.state.invoiceEndDate == undefined || this.state.invoiceEndDate == "") {
            errors.invoiceEndDate = "La Fecha de Vencimiento de la Factura es Obligatoria";
            error = true;
        }

        if (this.state.addedItems.length <= 0) {
            errors.addedItems = "Para generar la Factura debe existir por lo menos 1 item";
            error = true;
        }

        this.setState({ errors: errors });
        if (error == true && this.state.activeTab != "2") {
            this.setState({ activeTab: "2" });
        }
        return error;
    }

    generateComercialInvoice = async () => {
        if (!this.validate()) {
            let dataSend = {
                tipo_cliente: this.state.typeClient,
                tipo_negocio: this.state.typeBusiness,
                cliente: this.state.client,
                copago: this.state.money != undefined && this.state.money != null && this.state.money != "" ? this.state.money : 0,
                metodo_pago: this.state.paymentMethod,
                concepto_pago: this.state.paymentConcept,
                items: this.state.addedItems,
                total: this.calculateTotal(),
                subtotal: this.state.totalFormat,
                tipo_negociacion: this.state.typeBusiness,
                fecha_vencimiento: this.state.invoiceEndDate
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/create-comercial-invoice', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Ha ocurrido un error generando la Factura');
                }
            }).then(data => {
                this.setState({
                    colorAlertModal: 'success',
                    titleAlertModal: "Factura Generada",
                    openAlertModal: true,
                    messageAlertModal: "La Factura ha sido generada exitosamente"
                });
            }).catch((error) => {
                console.log(error);
                this.setState({
                    colorAlertModal: 'danger',
                    titleAlertModal: "Error",
                    openAlertModal: true,
                    messageAlertModal: "Ha ocurrido un error generando la Factura"
                });
            });
        }

    }

    onOkAlertModal = () => {
        let processed = false;
        if (this.state.colorAlertModal == "success") {
            processed = true;
        }
        this.setState({
            colorAlertModal: 'info',
            titleAlertModal: "",
            openAlertModal: false,
            messageAlertModal: ""
        }, () => {
            console.log("processed");
            if (processed) {
                this.finishProcessCreateInvoice();
            }
        });
    }

    finishProcessCreateInvoice = async () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/management/search-invoice-costumer'
        });
    }

    onToggleAlertModal = () => {
        this.setState({
            colorAlertModal: 'info',
            titleAlertModal: "",
            openAlertModal: false,
            messageAlertModal: ""
        });
    }

    previsualizateInvoice = async () => {
        if (!this.validate()) {
            let dataSend = {
                tipo_cliente: this.state.typeClient,
                tipo_negocio: this.state.typeBusiness,
                cliente: this.state.client,
                copago: this.state.money != undefined && this.state.money != null && this.state.money != "" ? this.state.money : 0,
                metodo_pago: this.state.paymentMethod,
                concepto_pago: this.state.paymentConcept,
                items: this.state.addedItems,
                total: this.calculateTotal(),
                subtotal: this.state.totalFormat,
                tipo_negociacion: this.state.typeBusiness,
                fecha_vencimiento: this.state.invoiceEndDate
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/previsualizate-comercial-invoice', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Ha ocurrido un error previsualizando la Factura');
                }
            }).then(res => {
                this.setState({ openModalPrintPDF: true }, () => {
                    let InvoiceUt = new InvoiceUtils();
                    InvoiceUt.generatePDFComercialInvoice(res.factura, res.clinica, res.autorizacion_text, res.cufe, res.url_dian);
                })
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    render() {
        const AddedItemsComponent = () => {
            return (<ItemsList reactTableData={this.state.addedItems} removeItem={this.removeItem} ReactTableActions={ItemsListActions} />);
        }

        return (
            <Card>
                <CardBody>
                    <div style={{ margin: 5 }}>
                        <div style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }} >
                            <Container>
                                <b>Datos Comerciales</b>
                                <br />
                                <FormInvoiceData
                                    typeBusiness={this.state.typeBusiness}
                                    money={this.state.money}
                                    paymentConcept={this.state.paymentConcept}
                                    paymentMethod={this.state.paymentMethod}
                                    invoiceEndDate={this.state.invoiceEndDate}
                                    handleTypeBusiness={this.handleTypeBusiness}
                                    handleMoney={this.handleMoney}
                                    handlePaymentMethod={this.handlePaymentMethod}
                                    handlePaymentConcept={this.handlePaymentConcept}
                                    handleInvoiceEndDate={this.handleInvoiceEndDate}
                                    errors={this.state.errors}
                                />
                                <br />
                            </Container>
                        </div>
                        <br />
                        <div style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }} >
                            <Container>
                                <b>Datos del Cliente</b>
                                <br />
                                <FormClientInvoice
                                    typeClient={this.state.typeClient}
                                    client={this.state.client}
                                    handleTypeClient={this.handleTypeClient}
                                    handleClient={this.handleClient}
                                    errors={this.state.errors}
                                    cleanDataPatient={this.cleanDataPatient}
                                />
                                <br />
                            </Container>
                        </div>
                        <br />
                        <div style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }} >
                            <Container>
                                <div style={{ margin: 5 }}>
                                    <br />
                                    <Tooltip title="Buscar Servicios">
                                        <Button
                                            outline
                                            color="primary"
                                            style={{ marginLeft: 20, }}
                                            onClick={() => {
                                                this.setState({ modalServices: true })
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faBookMedical} />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Buscar Articulos en Inventario">
                                        <Button
                                            outline
                                            color="primary"
                                            style={{ marginLeft: 20, }}
                                            onClick={() => {
                                                this.setState({ modalInventory: true })
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faBox} />
                                        </Button>
                                    </Tooltip>
                                </div>
                                <b>Datos de los Items</b>
                                <br />
                                <FormItem
                                    addItem={this.addItem}
                                    item={this.state.item}
                                    cost={this.state.cost}
                                    units={this.state.units}
                                    itemType={this.state.itemType}
                                    taxType={this.state.taxType}
                                    handleItem={this.handleItem}
                                    handleCost={this.handleCost}
                                    handleUnits={this.handleUnits}
                                    handleItemType={this.handleItemType}
                                    handleTaxType={this.handleTaxType}
                                />
                                <AddedItemsComponent />
                                <br />
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                    <div>
                                        <h4>Subtotal $ {this.state.totalFormat != null && this.state.totalFormat != undefined && this.state.totalFormat != "" ? formatNumber(Math.ceil(this.state.totalFormat)) : 0}</h4>
                                    </div>
                                    <div>
                                        <h4>Copago $ {this.state.money != null && this.state.money != undefined && this.state.money != "" ? formatNumber(Math.ceil(this.state.money)) : 0}</h4>
                                    </div>
                                    <div>
                                        <h4>Total $ {formatNumber(Math.ceil(this.calculateTotal()))}</h4>
                                    </div>
                                    <div>
                                        <h4>IVA $ {formatNumber(Math.ceil(this.state.acc_valor_iva))}</h4>
                                    </div>
                                </div>
                                <br />
                                <div style={{ display: 'flex', marginTop: 5, marginRight: 50, justifyContent: 'flex-end' }}>
                                    <Button
                                        style={{ margin: 10, }}
                                        color="primary"
                                        size="sm"
                                        disabled={!(this.state.addedItems.length > 0)}
                                        onClick={() => {
                                            this.previsualizateInvoice();
                                        }}
                                    >
                                        <PrintIcon /> Previsualizar
                                    </Button>

                                    <Button
                                        style={{ margin: 10, }}
                                        color="primary"
                                        size="sm"
                                        disabled={!(this.state.addedItems.length > 0)}
                                        onClick={() => {
                                            this.generateComercialInvoice();
                                        }}
                                    >
                                        <SaveIcon /> Guardar
                                    </Button>
                                </div>
                            </Container>
                            <br />
                        </div>
                    </div>
                    <br />

                    <ModalInventoryList
                        opened={this.state.modalInventory}
                        closeModal={() => this.setState({ modalInventory: false })}
                        preAddItemArticle={this.preAddItemArticle}
                    />

                    <ModalServicesList
                        opened={this.state.modalServices}
                        closeModal={() => this.setState({ modalServices: false })}
                        preAddItemService={this.preAddItemService}
                    />

                    <AlertModal
                        color={this.state.colorAlertModal}
                        title={this.state.titleAlertModal}
                        modal={this.state.openAlertModal}
                        message={this.state.messageAlertModal}
                        onOk={() => this.onOkAlertModal(false)}
                        toggle={() => this.onToggleAlertModal(false)}
                    />

                    <ModalTemplatePdf openModal={this.state.openModalPrintPDF} closeModal={() => this.setState({ openModalPrintPDF: false })} />

                </CardBody>
            </Card>
        );
    }
}

export default ManualInvoiceReport;
